import PlusIcon from "app/components/Icons/PlusIcon";
import React from "react";

interface CustomProps {
  title: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const AddButton: React.FC<CustomProps> = ({ title, onClick }) => {
  return (
    <>
      <button
        className="flex flex-row w-fit items-center gap-1 hover:bg-gray-200 "
        onClick={onClick}
      >
       
        <PlusIcon color="#5A8DF1"/>
        <span className="text-sm leading-[24px] text-primary font-semibold mt-[2px] font-sans">
          {title}
        </span>
      </button>
    </>
  );
};

export default AddButton;
